export default "__VITE_ASSET__CwCbtlmP__"